module.exports = __webpack_public_path__ + "assets/img/extra-logo.6d843228.png";